import endpoints from "../constants/env/middletier";
import React, { useState, useEffect, useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";
import ProjectContextDropdown from '../components/ProjectContextDropdown';
import { useProject } from "../context/ProjectContextProvider";
import { useAuth } from '../AuthProvider'
import EquipmentDetails from "../components/EquipmentDetails";

export default function CxSystemsPage() {
    const [allSystems, setAllSystems] = useState(null);
    const [systemEquipmentReferences, setSystemEquipmentReferences] = useState(null);
    const [selectedEquipmentId, setSelectedEquipmentId] = useState(null);
    const [selectedEquipment, setSelectedEquipment] = useState(null);
    const [selectedEquipmentDropdownItem, setSelectedEquipmentDropdownItem] = useState(null);
    const [columnExpanded, setColumnExpanded] = useState(false);
    const toast = useRef(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const { project } = useProject();
    const { keycloak } = useAuth()

    const [columns, setColumns] = useState([
        {field: 'name', header: 'Name'},
        {field: 'tag', header: 'Tag'},
        {field: 'systemTypeName', header: 'System Type'}
    ]);

    const fetchSystems = async () => {
        try {
            await keycloak.updateToken(30);
            const systemsByProject = await fetch(`${endpoints.systemsbyproject}${project.value}`, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                },
            });

            if (!systemsByProject.ok) {
                throw new Error("Logs: Bad response");
            }

            const projectsData = await systemsByProject.json();
            setAllSystems(projectsData);

        } catch (error) {
            console.error("Failed to fetch clients:", error);
        }
    };

    useEffect(() => {
        fetchSystems();
    }, []);


    const fetchSelectedEquipment = async (equipmentId) => {
        try {
            await keycloak.updateToken(30);
            const equipment = await fetch(`${endpoints.cxequipment}${equipmentId}`, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                },
            });

            if (!equipment.ok) {
                throw new Error("Logs: Bad response");
            }

            const equipmentData = await equipment.json();
            setSelectedEquipment(equipmentData)

        } catch (error) {
            console.error("Failed to fetch equipment:", error);
        }
    };

    const handleAddColumns = async (e) => {
        e.preventDefault();

        try {
            if(columnExpanded){
                setColumns(prev => [
                    {field: 'name', header: 'Name'},
                    {field: 'tag', header: 'Tag'},
                    {field: 'systemTypeName', header: 'System Type'}
                ]);
                setColumnExpanded(false);
            } else {
                setColumns(prev => [
                    ...prev,
                    {field: 'parentSystemTag', header: 'Parent System Tag'},
                    {field: 'notes', header: 'Notes'},
                    {field: 'description', header: 'Description'},
                    {field: 'createdAt', header: 'Created'}
                ]);
                setColumnExpanded(true);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
        }
    };

    const header = (
        <div className="flex align-items-center justify-content-between">
            <span className="text-xl text-900 font-bold">
                Systems
            </span>

            <div className="p-inputgroup" style={{ width: 'auto' }}>
                <Button icon={columnExpanded ? 'pi pi-caret-left' : 'pi pi-caret-right'}  label={columnExpanded ? 'Less Columns...' : 'All Columns...'}
                        text severity="secondary" onClick={handleAddColumns} />
            </div>
        </div>
    );

    const handleProjectSelectionDataTable = async (e) => {
        await keycloak.updateToken(30);

        const SystemsByProject = await fetch(`${endpoints.systemsbyproject}/${e}`, {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${keycloak.token}`,
            },
        });


        if (!SystemsByProject.ok) {
            throw new Error("Logs: Bad response");
        }

        const projectsData = await SystemsByProject.json();
        setAllSystems(projectsData);
    };

    const onSystemRowSelect = (event) => {
        setSystemEquipmentReferences(event.data.systemEquipmentReferences);
        setSelectedEquipmentId(null);
        setDialogVisible(true);
    };

    const onEquipmentDropdownSelect = async (event) => {
        setSelectedEquipmentId(event.value.equipmentId);
        setSelectedEquipmentDropdownItem(event.value);

        await fetchSelectedEquipment(event.value.equipmentId);
    };

    const openDetails = async (rowData) => {
        console.log(rowData);
        // setSelectedEquipment(rowData);
        await fetchSelectedEquipment(rowData.equipmentId);
        setSelectedEquipmentId(rowData.equipmentId);
        setDialogVisible(true);

    };
    const detailsButton = (rowData) => (
        <>
            {(rowData.systemEquipmentReferences ?? []).map((reference) => (
                <Button
                    key={reference.id}
                    label={reference.label}
                    severity="info"
                    size="small"
                    text
                    onClick={() => openDetails(reference)}
                    aria-label={`View details for ${reference.label}`}
                />

            ))}
        </>
    );

    return (
        <>
           <ProjectContextDropdown onProjectChange={handleProjectSelectionDataTable} />
           <Toast ref={toast} />

            <Dialog header="Equipment Reference" visible={dialogVisible}
                    style={{ width: '55vw' }} maximizable
                    onHide={() => setDialogVisible(false)}>

                {/*<Dropdown value={selectedEquipmentDropdownItem} onChange={onEquipmentDropdownSelect}*/}
                {/*          options={systemEquipmentReferences} optionLabel="label"*/}
                {/*          placeholder="Select an Equipment Reference" className="w-full md:w-14rem" />*/}
                {/*<br />*/}
                {/*<br />*/}

                { selectedEquipmentId && <EquipmentDetails equipment={selectedEquipment} />}

            </Dialog>

            <div className="card">
                <DataTable value={allSystems} header={header} tableStyle={{ minWidth: '50rem' }}>
                    {columns.map((col, i) => (
                        <Column key={col.field} field={col.field} header={col.header} />
                    ))}
                    <Column field="equipmentTags" header="Equipment Tags" body={detailsButton}></Column>
                </DataTable>
            </div>
        </ >
    );
}























